/**
 * 字典調試工具
 * 
 * 用於調試和監控字典加載過程
 */

/**
 * 檢查環境配置
 */
export const checkEnvironment = () => {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || process.env.SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.SUPABASE_ANON_KEY;
  
  const config = {
    supabaseUrl: supabaseUrl || '未設置',
    supabaseKey: supabaseKey ? '已設置' : '未設置',
    configured: !!(supabaseUrl && supabaseKey),
  };
  
  // 開發環境下輸出詳細配置信息（不輸出完整的 key）
  if (process.env.NODE_ENV === 'development') {
    console.log('[Dictionary Debug] 環境配置檢查:', {
      ...config,
      supabaseUrlValue: supabaseUrl ? `${supabaseUrl.substring(0, 30)}...` : '未設置',
      supabaseKeyValue: supabaseKey ? `${supabaseKey.substring(0, 20)}...` : '未設置',
      envVars: {
        REACT_APP_SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL ? '已設置' : '未設置',
        SUPABASE_URL: process.env.SUPABASE_URL ? '已設置' : '未設置',
        REACT_APP_SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY ? '已設置' : '未設置',
        SUPABASE_ANON_KEY: process.env.SUPABASE_ANON_KEY ? '已設置' : '未設置',
      }
    });
  }
  
  return config;
};

/**
 * 調試日誌
 */
export const debugLog = (message, data = null) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(`[Dictionary Debug] ${message}`, data || '');
  }
};

/**
 * 檢查字典數據結構
 */
export const validateDictionaryStructure = (dictName, dictData) => {
  if (!dictData) {
    debugLog(`❌ ${dictName}: 數據為空`);
    return false;
  }
  
  const keys = Object.keys(dictData);
  debugLog(`✓ ${dictName}: 找到 ${keys.length} 個鍵`, keys);
  
  // 檢查關鍵結構
  const requiredKeys = {
    MTR: ['Common', 'MtrLines', 'MtrStations'],
    LRT: ['lrtCommon', 'lrtStations', 'lrtRoutes'],
    MTRBus: ['common', 'route', 'stops'],
    MTRStatus: ['status'],
    TrafficNews: ['categories'],
    Immigration: ['ports'],
  };
  
  if (requiredKeys[dictName]) {
    const missing = requiredKeys[dictName].filter(key => !dictData[key]);
    if (missing.length > 0) {
      debugLog(`⚠️ ${dictName}: 缺少關鍵鍵`, missing);
      return false;
    }
  }
  
  return true;
};

/**
 * 性能監控
 */
export const measurePerformance = (label, fn) => {
  if (process.env.NODE_ENV === 'development') {
    const start = performance.now();
    const result = fn();
    const end = performance.now();
    debugLog(`⏱️ ${label}: ${(end - start).toFixed(2)}ms`);
    return result;
  }
  return fn();
};


